export const getStripeWithdrawalSetup = async (welletContext) => {
  try {
    const response = await welletContext.apis.tickets.get('/withdrawal/stripe/setup');
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getStripeOnboardingRefreshLink = async (welletContext, onboardingToken) => {
  try {
    const response = await welletContext.apis.tickets.post(
      '/withdrawal/stripe/RefreshOnboardingLink',
      {
        onboardingToken,
      },
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getStripeOnboardingStatus = async (welletContext, onboardingToken) => {
  try {
    const response = await welletContext.apis.tickets.post('/withdrawal/stripe/status', {
      onboardingToken,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const getBankAccount = async (welletContext) => {
  try {
    const response = await welletContext.apis.tickets.get('/withdrawal/external-account');
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
